import { checkDecimalPlaces, globalSettings, numberTruncator, responseGet, numberSet, separatorsNumbersSet, isUndNullEmp, lodash, isUndNull } from '../../helpers/settings'
import { purchaseModelGet } from '../../models/expenses/purchase';

export const purchaseDetailsCalculate = ({
    neutralValue = 0.00,
    purchaseDetails = [],
    purchase = purchaseModelGet({}),
    setPurchase = () => { },
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'purchaseDetailsCalculate';
    let response = responseGet();
    try {
        //#region variables
        //#region old code
        //let amounts?.subTotal = neutralValue;
        //let amounts?.taxBase = neutralValue;
        //let amounts?.taxPercentageTwo = neutralValue;
        //let taxId = '';
        //let amounts?.taxAmount = neutralValue;
        //let amounts?.total = neutralValue;
        //let amounts?.exemptAmount = neutralValue;
        //#endregion old code
        let taxId = '';
        const amounts = {
            subTotal: neutralValue,
            taxBase: neutralValue,
            taxPercentageTwo: neutralValue,
            taxAmount: neutralValue,
            total: neutralValue,
            exemptAmount: neutralValue,
        };
        //#endregion variables

        //#region check tax maximum
        response = checkTaxMaximum({
            purchaseDetails: purchaseDetails,
            languageId: languageId,
            subMethod: currentMethod,
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
        //#endregion check tax maximum

        //#region set subTotal, tax, taxAmount, total, exemptAmount, taxBase
        purchaseDetails?.forEach((detail) => {
            //#region variables
            const amountsObj = {
                quantity: checkDecimalPlaces({
                    number: detail?.quantity,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result,
                price: checkDecimalPlaces({
                    number: detail?.price,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result,
            };
            const subTotalTwoLocal = numberTruncator({
                number: (amountsObj?.quantity * amountsObj?.price),
                decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                languageId: languageId,
                subMethod: currentMethod,
            })?.result;
            let percentageLocal = neutralValue;
            let taxAmountTwoLocal = neutralValue;
            //#endregion variables

            //#region methods
            if (subTotalTwoLocal !== neutralValue) {
                amounts.subTotal = numberTruncator({
                    number: (checkDecimalPlaces({
                        number: amounts?.subTotal,
                        languageId: languageId,
                        subMethod: currentMethod,
                    })?.result + subTotalTwoLocal),
                    decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result;
            }

            amounts.taxPercentageTwo = amounts?.taxPercentageTwo === 0 && detail?.taxPercentage > 0 ? detail?.taxPercentage : amounts?.taxPercentageTwo;

            //#region old code
            //localTaxId = (isEmpty(localTaxId) && detail.taxId ? detail.taxId : localTaxId);
            //#endregion old code

            taxId = isUndNullEmp({ data: taxId, subMethod: currentMethod, })?.result && !isUndNullEmp({ data: detail?.taxId, subMethod: currentMethod, })?.result ? detail?.taxId : taxId;
            if (!isUndNull({ data: detail?.taxPercentage, subMethod: currentMethod, })?.result && detail?.taxPercentage > neutralValue && subTotalTwoLocal > neutralValue) {
                amounts.taxBase = numberTruncator({
                    number: (checkDecimalPlaces({
                        number: amounts?.taxBase,
                        languageId: languageId,
                        subMethod: currentMethod,
                    })?.result + subTotalTwoLocal),
                    decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result;
            }

            if (!isUndNull({ data: detail?.taxPercentage, subMethod: currentMethod, })?.result && detail?.taxPercentage === neutralValue && subTotalTwoLocal > neutralValue) {
                amounts.exemptAmount = numberTruncator({
                    number: (checkDecimalPlaces({
                        number: amounts?.exemptAmount,
                        languageId: languageId,
                        subMethod: currentMethod,
                    })?.result + subTotalTwoLocal),
                    decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                    languageId: languageId,
                    subMethod: currentMethod,
                }).result;
            }

            if (!isUndNull({ data: detail?.taxPercentage, subMethod: currentMethod, })?.result && detail?.taxPercentage > neutralValue) {
                percentageLocal = numberTruncator({
                    number: (detail?.taxPercentage / 100.00),
                    decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result;
            }

            if (subTotalTwoLocal !== neutralValue && percentageLocal > neutralValue) {
                taxAmountTwoLocal = numberTruncator({
                    number: (subTotalTwoLocal * percentageLocal),
                    decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result;
            }

            if (detail?.taxPercentage !== neutralValue) {
                amounts.taxAmount = numberTruncator({
                    number: (checkDecimalPlaces({
                        number: amounts?.taxAmount,
                        languageId: languageId,
                        subMethod: currentMethod,
                    })?.result + taxAmountTwoLocal),
                    decimalPlaces: globalSettings?.numberPositions?.decimalPlaces,
                    languageId: languageId,
                    subMethod: currentMethod,
                })?.result;
            }
            //#endregion methods
        });

        amounts.total = numberSet({
            number: (amounts?.subTotal + amounts?.taxAmount),
            type: 'd',
            languageId: languageId,
            subMethod: currentMethod,
        })?.result;

        setPurchase({
            ...purchase,
            balance: amounts?.total,
            subTotal: amounts?.subTotal,
            taxBase: amounts?.taxBase,
            exemptAmount: amounts?.exemptAmount,
            taxId: taxId,
            taxPercentage: amounts?.taxPercentageTwo,
            total: amounts?.total,
            taxAmount: amounts?.taxAmount,
        });
        //#endregion set subTotal, tax, taxAmount, total, exemptAmount, taxBase
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const checkTaxMaximum = ({
    purchaseDetails = [],
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'checkTaxMaximum';
    let response = responseGet();
    try {
        if (!isUndNullEmp({ data: purchaseDetails, subMethod: currentMethod, })?.result && purchaseDetails?.length > 0) {
            purchaseDetails = purchaseDetails?.filter(({ taxId, taxPercentage, }) => taxId !== '' && !isUndNullEmp({ data: taxId, subMethod: currentMethod, })?.result && taxPercentage !== 0.00);
            if (!isUndNullEmp({ data: purchaseDetails, subMethod: currentMethod, })?.result && purchaseDetails?.length > 0) {
                const taxPercentages = lodash?.unique({
                    data: purchaseDetails,
                    key: globalSettings?.collections?.properties?.taxId,
                    subMethod: currentMethod,
                })?.result || [];
                if (!isUndNullEmp({ data: taxPercentages, subMethod: currentMethod, })?.result && taxPercentages?.length > 1) {
                    response.msgType = 1
                    response.isWarning = true;
                    response.msgText = `${globalSettings?.messages?.onlyOneTypeTaxAndExemptIsAllowed?.[languageId]}<br/>`;
                    taxPercentages?.forEach((detail, index) => {
                        response.msgText += `${globalSettings?.labels?.tax?.[languageId]} ${index + 1}: <b>${separatorsNumbersSet({
                            number: detail?.taxPercentage,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result
                            }</b><br/>`
                    });
                    response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageId]}`;
                }
            }
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}